// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1YHRN","insightsList":"newBusinessInsightsMenu_insightsList__29EAE","active":"newBusinessInsightsMenu_active__1341B"};